/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateBankAccountSuffixToFourDigitsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateBankAccountSuffixToFourDigits.pb'
import {UpdateBankAccountSuffixToFourDigitsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateBankAccountSuffixToFourDigits.pb'


export const updateBankAccountSuffixToFourDigits = (request:UpdateBankAccountSuffixToFourDigitsRequest, options?: CashRequestOptions) => post<UpdateBankAccountSuffixToFourDigitsRequest, UpdateBankAccountSuffixToFourDigitsResponse>("/2.0/cash/update-bank-account-suffix-to-four-digits", request, {...options, rejectOnError: true })